import { z } from 'zod';
import { useDialogFormControls, CommanderFormProps } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { ReservationAsyncSelect } from '../../ReservationAsyncSelect/ReservationAsyncSelect';
import { useGetPaymentRequestDetailSuspense } from './hooks';

interface PaymentRequestLinkFormProps extends CommanderFormProps {
    paymentRequestId: string;
    accountId: string;
}

// TODO: use schema in resolver
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ServiceOrderPaymentRequestLinkFormSchema = z.object({
    serviceOrderId: z.string().nullish(),
});

type PaymentRequestLinkFormValues = z.infer<typeof ServiceOrderPaymentRequestLinkFormSchema>;

export const PaymentRequestLinkForm = ({
    paymentRequestId,
    accountId,
    onSubmitting,
    onSubmitted,
    onSuccess,
    formRef,
}: PaymentRequestLinkFormProps) => {
    const { data } = useGetPaymentRequestDetailSuspense({ paymentRequestId });
    const { mutate } = useRepositoryMutation('paymentRequests', 'updateServiceOrderLink', {
        invalidateQueries: { paymentRequests: ['getAll'] },
    });
    const defaultServiceOrderId = data?.serviceOrderId;

    /**
     * defaultValue value is provided directly by the link field
     */
    const { renderFormContent } = useDialogFormControls<PaymentRequestLinkFormValues>({
        formRef,
        onSubmit: ({ serviceOrderId }) => {
            onSubmitting?.();
            mutate(
                { paymentRequestUpdates: [{ id: paymentRequestId, serviceOrderId: serviceOrderId ?? null }] },
                {
                    onSettled: onSubmitted,
                    onSuccess,
                }
            );
        },
    });

    return renderFormContent(
        <ReservationAsyncSelect
            name="serviceOrderId"
            label={lt('ProcessPaymentLinkPaymentToReservationReservationSelectLabel')}
            accountId={accountId}
            defaultValue={defaultServiceOrderId}
            size="medium"
        />
    );
};
